import feathersClient, {
    makeServicePlugin,
    BaseModel
} from '../feathers-client.js'

class Items extends BaseModel {
    // eslint-disable-next-line no-useless-constructor
    constructor (data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'Items'

    // Define default properties here
    static instanceDefaults () {
        return {
            name: '',
            isCompleted: '',
            notes: ''
        }
    }
}

const servicePath = 'items'
const servicePlugin = makeServicePlugin({
    Model: Items,
    service: feathersClient.service(servicePath),
    servicePath,
    skipRequestIfExists: true,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
})

export default servicePlugin
